import { ChangeDetectionStrategy, Component, EventEmitter, Output, computed, input } from '@angular/core';

import { MyBetsConfig, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { LabelSwitcherService } from '@frontend/vanilla/features/label-switcher';
import { Observable, map } from 'rxjs';

import { IPlacedBetInfo } from '../../../share-my-bet/share-my-bet.state';

@Component({
    selector: 'ms-my-bets-toolbar-redesign',
    templateUrl: 'my-bets-toolbar-redesign.component.html',
    styleUrl: './my-bets-toolbar-redesign.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyBetsToolbarRedesignComponent {
    @Output() onBetslipIdClick = new EventEmitter<Event>();
    @Output() onEditBetHistoryClick = new EventEmitter<Event>();

    betPlacedDate = input.required<Date>();
    betslipId = input.required<string>();
    showShareMyBetButton = input.required<boolean>();
    showEditBetHistoryButton = input.required<boolean>();
    placedBetInfo = input.required<IPlacedBetInfo>();
    showRegionCode: boolean = this.myBetsConfig.showRegionCode;
    regionCode$: Observable<string> = this.labelSwitcherService.currentLabelItemEvent$?.pipe(
        map((currentLabelItemEvent) => (currentLabelItemEvent?.regionCode ? currentLabelItemEvent.regionCode + ' • ' : '')),
    );

    isMyBetsFooterIconsVisible = computed(() => this.showEditBetHistoryButton() || this.showShareMyBetButton());

    constructor(
        public sitecoreMyBets: SitecoreMyBetsConfig,
        private labelSwitcherService: LabelSwitcherService,
        private myBetsConfig: MyBetsConfig,
    ) {}

    copyToClipboard(event: Event): void {
        this.onBetslipIdClick.emit(event);
    }

    editBetHistory(event: Event): void {
        this.onEditBetHistoryClick.emit(event);
    }
}
